const rules = {
  lastName: {
    required: true
  },
  firstName: {
    required: true
  },
  lastNameKana: {
    required: true
  },
  firstNameKana: {
    required: true
  },
  tel: {
    required: false,
    tel: true
  },
  email: {
    required: true,
    mail: true
  },
  inquiry: {
    required: true
  }
};

const messages = {
  lastName: {
    required: '入力してください'
  },
  firstName: {
    required: '入力してください'
  },
  lastNameKana: {
    required: '入力してください'
  },
  firstNameKana: {
    required: '入力してください'
  },
  tel: {
    required: '入力してください',
    tel: '正しい電話番号を入力してください'
  },
  email: {
    required: '入力してください',
    mail: '正しいメールアドレスを入力してください'
  },
  inquiry: {
    required: '入力してください'
  }
};

const methods = {
  halfchara: function halfchara( value, element ){
    return this.optional(element) || /^[a-zA-Z0-9!-/:-@¥[-`{-~]*$/.test(value);
  },
  halfWidth: function halfWidth( value, element ){
    return this.optional(element) || /^[a-zA-Z0-9]*$/.test(value);
  },
  kana: function number( value, element ){
    return this.optional(element) || /^([ぁ-んァ-ンヴー]+)$/.test(value);
  },
  number: function number( value, element ){
    return this.optional(element) || /^([0-9]+)$/.test(value);
  },
  tel: function tel( value, element ) {
    // 電話番号のバリデーション
    return this.optional(element) || /^\d{10,11}$/.test(value);
  },
  mail: function mail( value, element ) {
    // メールアドレスのバリデーション
    return this.optional(element) || /^([a-zA-Z0-9])+([a-zA-Z0-9\._-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9\._-]+)+$/.test(value);
  },
  local: function local( value, element ){
    // 番地入力のチェック
    return this.optional(element) || /([0-9０-９]+|[一二三四五六七八九十百千]+)+(([0-9０-９]+|[一二三四五六七八九十百千]+)|(番町|丁目|丁|番地|番|号|-|‐|–|ー|−|－|の))*(([0-9０-９]+|[一二三四五六七八九十百千]+)+|(丁目|丁|番地|番|号))/.test(value);
  }
};
// メソッドの追加（上記の追加ルールを適用させる）
$.each( methods, function(key){
  $.validator.addMethod( key, this );
});



$(function(){
  $('#contactForm').validate({
    rules    : rules,
    messages : messages,
    onfocusout: function onfocusout(element){
      if ( ! this.checkable(element) ) { this.element(element); }
    },
    errorPlacement: function errorPlacement( error, element ){
      // チェックボックス用に [] を取り除く
      const eleName = '#' + element.attr('name').replace( /\[\]/g, '' );
      error.prependTo( eleName + '_error' );
    },
    submitHandler: function(form){
      const formValue = $(form).serialize();
      $.post(
        '/contact/contact.confirm.php', formValue
      ).done( function(res) {
        modalOpenExec(res);
      });
      return;
    }
  });
});
